import { useDispatch } from "react-redux";
import { FunnelType, Step } from "@/types/enums";
import type { UnitGroup } from "@/types";
import {
    initializeJourney,
} from "@/features/journey/journeySlice";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { getSteps } from "@/hooks/useSteps";

export const useActivateRentalJourney = () => {
    const dispatch = useDispatch();
    const { buttonLayout } = useDisplayOptionContext();

    const activateRentalJourney = (
        unitId: number | string,
        unitGroup: UnitGroup,
        selectedPromo: number
    ) => {
        const subGroupCount = unitGroup.sub_groups?.length ?? 0;
        const steps = getSteps(subGroupCount, buttonLayout);

        // Determine the initial step based on subgroup count
        const step = unitGroup.sub_groups && unitGroup.sub_groups.length > 1
            ? Step.VBP
            : Step.FUNNEL;

        dispatch(
            initializeJourney({
                unitId,
                unitGroup,
                selectedPromo,
                stepList: steps,
                step,
                funnelType: FunnelType.RENT,
            }),
        );
    };

    return activateRentalJourney;
};
